export default {
  placeholder: 'Hae yritystä...',
};
